"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimplifiedRegistration = void 0;
var _auth = require("@ori/auth");
var _i18n = require("@ori/i18n");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _SimplifiedRegistrationContent = require("./SimplifiedRegistrationContent");
var _components = require("./components");
var _constantsGenerated = require("./constants-generated");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("./constants/defaultTranslations_simplified-registration-BrandPartner");
var _defaultTranslations_simplifiedRegistrationVIPCustomer = require("./constants/defaultTranslations_simplified-registration-VIPCustomer");
var _containers = require("./containers");
var _contexts = require("./contexts");
var _jsxRuntime = require("react/jsx-runtime");
const SimplifiedRegistration = ({
  registrationType,
  contentWithImage
}) => {
  const {
    formattedToken
  } = (0, _auth.useToken)();
  if (!formattedToken) {
    return null;
  }
  const correctNameSpace = registrationType === 'Consultant' ? _defaultTranslations_simplifiedRegistrationBrandPartner.translationsNamespace : _defaultTranslations_simplifiedRegistrationVIPCustomer.translationsNamespace;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
    namespace: correctNameSpace,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.ErrorBoundary, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _testidGenerator.Team.Acquisition,
        project: _constantsGenerated.APP_NAME,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.BasicSkeleton, {}),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.ApiProvider, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.VirtualPageAnalyticsProvider, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.RegisterStatusContainer, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.StepperProvider, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.NotificationProvider, {
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.FormErrorProvider, {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SimplifiedRegistrationContent.SimplifiedRegistrationContent, {
                        contentWithImage: contentWithImage
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
exports.SimplifiedRegistration = SimplifiedRegistration;